// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/icing-intensity.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/icing-intensity/icing-intensity.js';

mount([g0]);
